import React from 'react';

const RsdtBanner: React.FC = () => (
  <section className="rsdt-banner">
    <div className="rsdt-banner-inner">
      <h2>Microwave Sensors Development</h2>
      <p>MW Sensor — engineered for precise, privacy-first in-cabin radar intelligence.</p>
    </div>
  </section>
);

export default RsdtBanner;